import { CONTENT_MAX_WIDTH } from 'Util/constants'
import { Box, type BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  padding: theme.spacing(3),
  width: '100%',
  maxWidth: CONTENT_MAX_WIDTH
}))

function MainContent({ children }: Readonly<{ children: React.ReactNode }>) {
  return <StyledBox component="main">{children}</StyledBox>
}
export default MainContent
